import { ActivityLogParser } from '@/parsers/activityLog'
import { i18n } from '@/i18n'

export class CommissionSplitActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'split_rate': 'percentage',
        'active_from': 'date',
        'active_until': 'date',
    }

    static getLogDescriptionUpdated (activityLog, data) {
        const interpolationParams = {
            someone: data.causer,
            something: `<b>${i18n.tc('common.change-log.subject.some--target.commission-split', 1)}</b>`,
        }
        if (data.causer) {
            return i18n.t('common.change-log.someone-updated-something', interpolationParams)
        } else {
            return i18n.t('common.change-log.something-has-been-updated', interpolationParams)
        }
    }

    static getLogDetailsCreated (activityLog, data) {
        const logDetails = []

        logDetails.push (
            {
                key: 'additional_recipient_name',
                label: i18n.tc('forms.field.label.commission-split.additional-recipient-name', 1),
                newValue: activityLog.properties.attributes['additionalRecipient.name'],
            }
        )

        logDetails.push (
            {
                key: 'split_rate',
                label: i18n.tc('forms.field.label.commission-split.split-rate', 1),
                newValue: this.getFormattedLogDetailValue(activityLog, 'split_rate', this.attributeDataTypes['split_rate'] ?? 'undefined', activityLog.properties.attributes.split_rate),
            }
        )

        if (activityLog.properties.attributes.active_from) {
            logDetails.push (
                {
                    key: 'active_from',
                    label: i18n.tc('forms.field.label.address.valid-from', 1),
                    newValue: this.getFormattedLogDetailValue(activityLog, 'active_from', this.attributeDataTypes['active_from'] ?? 'undefined', activityLog.properties.attributes.active_from),
                }
            )
        }

        if (activityLog.properties.attributes.active_until) {
            logDetails.push (
                {
                    key: 'active_until',
                    label: i18n.tc('forms.field.label.address.valid-until', 1),
                    newValue: this.getFormattedLogDetailValue(activityLog, 'active_until', this.attributeDataTypes['active_until'] ?? 'undefined', activityLog.properties.attributes.active_until),
                }
            )
        }

        return logDetails
    }

    static getLogDetailsDeleted (activityLog, data) {
        const logDetails = []

        logDetails.push (
            {
                key: 'additional_recipient_name',
                label: i18n.tc('forms.field.label.commission-split.additional-recipient-name', 1),
                oldValue: activityLog.properties.old['additionalRecipient.name'],
            }
        )

        logDetails.push (
            {
                key: 'split_rate',
                label: i18n.tc('forms.field.label.commission-split.split-rate', 1),
                oldValue: this.getFormattedLogDetailValue(activityLog, 'split_rate', this.attributeDataTypes['split_rate'] ?? 'undefined', activityLog.properties.old.split_rate),
            }
        )

        if (activityLog.properties.old.active_from) {
            logDetails.push (
                {
                    key: 'active_from',
                    label: i18n.tc('forms.field.label.address.valid-from', 1),
                    oldValue: this.getFormattedLogDetailValue(activityLog, 'active_from', this.attributeDataTypes['active_from'] ?? 'undefined', activityLog.properties.old.active_from),
                }
            )
        }

        if (activityLog.properties.old.active_until) {
            logDetails.push (
                {
                    key: 'active_until',
                    label: i18n.tc('forms.field.label.address.valid-until', 1),
                    oldValue: this.getFormattedLogDetailValue(activityLog, 'active_until', this.attributeDataTypes['active_until'] ?? 'undefined', activityLog.properties.old.active_until),
                }
            )
        }

        return logDetails
    }
}
